app.ui.registerUi('switch', function(app) {
	var helpers = app.helpers.funcs;
	return {
		implementationExists: function() {
			return jQuery.fn.bootstrapSwitch ? true : false;
		},
        onLoaded: function (data) {
            if (data.hasJustLoaded(RESOURCE_NAME__DOM)) {
                this.init();
            }
        },
		init: function($scope) {
			if (!this.implementationExists()) return;
			var $switchElems = helpers.resolveScope('.switch-seed', $scope);
			var lws = {
				'mini': 10,
				'small': 9,
				'normal': 9,
				'large': 5
			};
			$switchElems.each(function(k, elem) {
				var $elem = $(elem);
				var lwKey = $elem.data('size');
				if (!lwKey) lwKey = 'normal';
				$elem.bootstrapSwitch({
					labelWidth: lws[lwKey]
				});
			});
		},
	};
});
